<nav class="steps" [ngClass]="{ 'steps--configurator-version': isConfiguratorVersion }">
    <ul class="steps__list">
        <ng-container *ngFor="let step of steps; let index = index">
            <li *ngIf="!isConfiguratorVersion && index > 0" class="steps__line"></li>
            <li
                class="steps__item"
                [class._is_active]="index === activeIndex"
                [class._is_in_past]="index < activeIndex"
                [class._is_in_future]="index > activeIndex"
            >
                <span class="steps__icon">
                    <mat-icon class="steps__complete" i18n="@@general.stepper.check">check</mat-icon>
                    <span class="steps__index">{{ index + 1 }}</span>
                </span>
                <span *ngIf="step.label" class="steps__label">{{ step.label }}</span>
            </li>
        </ng-container>
    </ul>
</nav>

<div class="content" [style.transform]="'translateX(' + activeIndex * -100 + '%)'">
    <ng-content select="mg-ui-stepper-step"></ng-content>
</div>
